import React, { type ReactElement, useState } from 'react';

import CustomToaster from '@components/CustomToaster';
import { useEventTracking } from '@hooks';
import useScrollPosition from '@hooks/useScrollPosition';
import { discounted_upgrade_path, login_by_email_path, root_path, subscribe_path } from '@routes';
import { ClickTarget, TrackingLocation, click } from '@tracking';

import { SlimNavProps } from '../interfaces';
import SlimNavContent from './Content';

const SlimNav = ({
  billingError,
  currentUser,
  flashMessages,
  hideSubscribeButton,
  isOnSubscriptionPage,
  proOfferCode,
  slimNavDarkModeEnabled,
}: SlimNavProps): ReactElement => {
  const [showScrollingNav, setShowScrollingNav] = useState<boolean>(false);
  const { Track, trackEvent } = useEventTracking({
    location: TrackingLocation.SlimNav,
  });

  useScrollPosition({
    deps: [],
    effect: ({ currPos }: { currPos: { x: number; y: number } }) =>
      setShowScrollingNav(currPos.y > 10),
    useWindow: true,
    wait: 100,
  });

  const handleLogoClick = () => {
    trackEvent(click({ clickTarget: ClickTarget.Logo, clickLink: root_path() }));
  };

  const handleSignInClick = () => {
    trackEvent(click({ clickTarget: ClickTarget.SignIn, clickLink: login_by_email_path() }));
  };

  const handleSubscribeNowClick = () => {
    trackEvent(click({ clickTarget: ClickTarget.Subscribe, clickLink: subscribe_path() }));
  };

  const handleUpgradeClick = () => {
    trackEvent(
      click({
        clickTarget: ClickTarget.Upgrade,
        clickLink: discounted_upgrade_path({ offer: proOfferCode }),
      })
    );
  };

  return (
    <Track>
      <div className="relative">
        <SlimNavContent
          currentUser={currentUser}
          handleLogoClick={handleLogoClick}
          handleSignInClick={handleSignInClick}
          handleSubscribeNowClick={handleSubscribeNowClick}
          handleUpgradeClick={handleUpgradeClick}
          hideSubscribeButton={hideSubscribeButton}
          isOnSubscriptionPage={isOnSubscriptionPage}
          proOfferCode={proOfferCode}
          showScrollingNav={showScrollingNav || slimNavDarkModeEnabled}
        />
        <CustomToaster flashMessages={flashMessages} billingError={billingError} />
      </div>
    </Track>
  );
};

export default SlimNav;
